import { DeviceService } from "core/service";
import { SaleRepository } from "core/repository";
import BaseRepository from "core/repository/base.repository";

class DeviceRepository extends BaseRepository {
  syncable = false;

  getEntityIdentifier() {
    return "device";
  }

  resourceName() {
    return "dispositivos";
  }

  getServiceProvider() {
    return DeviceService;
  }

  async delete(deviceUuid) {
    return this.mService.delete(deviceUuid);
  }

  async restore(deviceUuid) {
    return this.mService.edit(deviceUuid, { enabled: true });
  }

  async updateName(deviceUuid, name) {
    return this.mService.edit(deviceUuid, { name });
  }

  async updateConfig(deviceUuid, config) {
    return this.mService.edit(deviceUuid, { config });
  }

  async list({ filters, order, pagination }) {
    const currentUser = await this.mRuntime.get("currentUser");
    const result = await this.mService.fetch(currentUser.company_uuid, {
      filters,
      order,
      pagination
    });

    if (!result.success) {
      return result;
    }

    const entitiesPromises = result.data.map(async model => {
      const sale = await SaleRepository.getListOnline({
        filters: [
          {
            connector: "AND",
            field: "company_uuid",
            operation: "EQ",
            value: currentUser.company_uuid
          },
          {
            connector: "AND",
            field: "device_uuid",
            operation: "EQ",
            value: model.uuid
          },
          {
            connector: "AND",
            field: "status",
            operation: "EQ",
            value: "active"
          }
        ],
        order: [{ field: "created_at", direction: "DESC" }]
      });

      if (sale.success && sale.data.length !== 0) {
        model.lastSalesman = sale.data[0].salesman.name;
      }

      return this.modelToEntity(model);
    });

    result.data = await Promise.all(entitiesPromises);
    result.total = result.headers.total;
    result.perPage = result.headers["per-page"];
    return result;
  }
}

export default new DeviceRepository();



// WEBPACK FOOTER //
// ./src/core/repository/device.repository.js